import { createFileRoute } from '@tanstack/react-router';
import { HotelReservationsPage } from '@/pages/hotel';

export const Route = createFileRoute('/protected/_layout/hotel/_layout/')({
  component: HotelReservationsPage,
});
